import React from 'react';
import { useParams } from 'react-router';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const TermDetail: React.FC = () => {
    const { termId } = useParams<{ termId: string }>();
    return <CommonEmbed title="약관" path={`/terms/${termId}`} />;
};
